<template>
    <div class="card mb-3">
        <!-- <img style="display: none;" id='reportLogo' src='@/assets/report_logo.png' alt='Report Logo'> -->
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Group By" >
                                        <select class="form-control" size="large" v-model="inputGroupBy" @click.prevent="autoChange">
                                            <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div v-if="inputGroupBy == 'monthly'" class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="From"><br>
                                        <a-month-picker v-model="inputFrom" placeholder="Select month" style="width:100%" :format="monthFormat"/>
                                    </base-input>
                                </div>
        
                                <div class="col-md-7">
                                    <base-input alternative="" label="To"><br>
                                        <a-month-picker v-model="inputTo" placeholder="Select month" style="width:100%" :format="monthFormat"/>
                                    </base-input>
                                </div>
                            </div>
                            <div v-else class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="From"><br>
                                        <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Sort By" >
                                        <select class="form-control" size="large" v-model="inputSortBy" @click.prevent="sortChange">>
                                            <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                                <div class="col-md-2 mt-3 pt-3">
                                    <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                        {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                                    </button>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Division">
                                        <a-select mode="multiple" v-model="inputDivision" showSearch placeholder="All Division" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="divisionOption in divisionOptions" :key="divisionOption.id" :value="divisionOption.id">{{divisionOption.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input type="number" min="0" v-if="inputSortBy == 'total_amount' || inputSortBy == 'qty'" placeholder="" label="Show Top" v-model="inputShowTop" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;

                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%%;" @click.prevent="generateExcel"> Download excel </button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import * as ExcelJS from "exceljs";
    import { saveAs } from "file-saver";
    import { getReportDescription } from '../../utilities';

    import {
        mapState,
        mapActions
    } from 'vuex'

    var component_x;

    export default {
        components: {
            VueJsonToCsv
        },
        data() {
            return {
                accessCostPriceRights: [],
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputGroupBy: 'division_id,site',
                groupOptions: [
                    {key: 'division_id,site', value: 'Division,Site'},
                    {key: 'brand_id', value: 'Brand'},
                    {key: 'department_id', value: 'Department'},
                    {key: 'supplier_id', value: 'Supplier'},
                    {key: 'section_id', value: 'Section'},
                    
                ],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputLocation: [],
                locationOptions: [],
                // locationPath: [],

                inputSortBy: 'grouper_name',
                sortOptions: [
                    {key: 'quantity', value: 'Quantity'},
                    {key: 'amount', value: 'Amount'},
                    {key: 'cost', value: 'Cost'},
                    {key: 'margin_value', value: 'Margin Value'},
                    {key: 'margin', value: 'Margin'},
                    {key: 'grouper_name', value: 'Name'},
                    {key: 'site_name', value: 'Site'},
                ],
                currDate: moment().format("L_LT").split(":").join(";"),
                isSeparateSite: true,
                isShowDetail: true,
                inputFrom: moment().startOf('month'),
                inputTo: moment().endOf('month'),
                monthFormat: 'MM/YYYY',
                birSalesReports: [],
                params: {},
                showSortInfo: 'asc',
                inputShowTop: 0,
                JsonData: [],
                inputDivision: [],
                divisionOptions: []
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")

            // Load Access Cost/Price rights (system_module_id 123): 'Z' = cost, 'Y' = price.
            var accessCostPriceRightsRequest = await HTTPRequest.getRequest(component_x.endPoint + 'users/' + userId + "/access_rights?system_module_id=123", null)
            if (accessCostPriceRightsRequest && accessCostPriceRightsRequest.access_rights && accessCostPriceRightsRequest.access_rights[123]) {
                component_x.accessCostPriceRights = accessCostPriceRightsRequest.access_rights[123]
            } else {
                component_x.accessCostPriceRights = []
            }

            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            if(component_x.categoriesOptions.length == 0){
                var options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                component_x.updateCategoriesOptions(options)
            }

            this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            this.reportDescription = await getReportDescription(this.currentProfile)
            await component_x.getDivisionOptions();

        },
        computed: {
            ...mapState(['currentProfile', 'endPoint', 'categoriesOptions']),
        },
        methods: {
            ...mapActions(['updateCategoriesOptions']),
            moment,
            async onLocationChange(){
                // alert(this.inputLocation);
                this.siteOptions = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                this.inputSite = this.siteOptions.map( s => s.id);
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            autoChange(e){
                if(e.target.value == ''){
                    this.isShowDetail = true
                }
            },
            sortChange(e){
                if(e.target.value != 'total_amount' || e.target.value != 'qty'){
                    this.inputShowTop = 0
                }
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            addMaskValidation(value, rights){
                if((!this.accessCostPriceRights.includes('Z') && rights == 'Z') || (!this.accessCostPriceRights.includes('Y') && rights == 'Y')){
                    return '***';
                }else{
                    return value
                }
            },
            changeParams(params){
                this.params = params

            },
            async findName(inputArray, optionsArray){
                let data = []
                inputArray.forEach((el) =>{
                    data.push(optionsArray.find(x => x.id === el).name)
                })
                return data
            },
            generateReport: async function () {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let filter_header = '' 
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "group_by": this.inputGroupBy,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "division_id": this.inputDivision.toString()    
                }

                let site_filter,date_filter,division_filter,group_filter
                // date, site, division, group and sort
                let groupBy = this.groupOptions.find(x => x.key == this.inputGroupBy).value
                let sortBy = this.sortOptions.find(x => x.key == this.inputSortBy).value
                group_filter = `Group By ${groupBy} Order by ${sortBy} ${this.showSortInfo}`
                date_filter = `For the Period of ${from_date} to ${to_date}`
                
                if(this.inputSite != undefined && this.inputSite.length > 0 && this.inputSite != [] && this.inputSite.length != this.siteOptions.length){
                    let sites = this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name)
                    site_filter = "Sites: " + sites 
                }else{
                    site_filter = "Sites: All Sites"
                }

                if(this.inputDivision != undefined && this.inputDivision.length > 0 && this.inputDivision != []){
                    let division = this.divisionOptions.filter(x => this.inputDivision.includes(x.id)).map(x => x.name)
                    division_filter = "Divisions: " + division
                }else{
                    division_filter = "Divisions: All Divisions"
                }

                
                var get_request = await HTTPRequest.getRequest(this.endPoint + 'sales_report_with_invoice?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                    return
                }
                var siteSpecific = get_request;
                
                let design_x = 0
                let design_y = 0

                let group_text = ""
                if(this.inputGroupBy != ''){
                    group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                }

                if(siteSpecific.length > 0){
                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let description = "Description"
                    if(this.inputGroupBy == "division_id,site"){
                        description = "Division Name"
                    }

                    let headers = [];
                    headers = [
                        [
                            {content: 'Site Name', styles: {halign: 'center', valign: 'center'}},
                            {content: description, styles: {halign: 'center', valign: 'center'}},
                            {content: 'Qty', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Amount', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Cost', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Sales Margin', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Sales Margin Value', styles: {halign: 'center', valign: 'center'}},
                        ]
                    ]

                    for(let x=0; x < siteSpecific.length; x++){
                        this.salesInvoiceReports = siteSpecific[x].sales_report

                        let total_qty = 0
                        let total_sales_value = 0
                        let total_sales_margin_value = 0
                        let total_cost_goods_sold = 0

                        let grand_qty = 0
                        let grand_sales_value = 0
                        let grand_sales_margin_value = 0
                        let grand_cost_goods_sold = 0

                        if(x > 0 && this.salesInvoiceReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];
                        let grouper = 'start'
                        let type_header = 'start'

                        if(this.salesInvoiceReports.length > 0){

                            for(let i=0; i < this.salesInvoiceReports.length; i++){
                                let reportLine = this.salesInvoiceReports[i]

                                let grouper_name = reportLine.grouper_name
                                let grouper_id = reportLine.grouper_id
                                if(this.inputGroupBy != ''){
                                    if(grouper == 'start'){
                                        let detail_header = [
                                            {content: `${grouper_name}`, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}
                                            ];
                                        reportData.push(Object.assign({}, detail_header))
                                    } else {
                                        if(grouper != grouper_id){
                                            let detail_header = [{content: `${grouper_name}`, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}
                                            ];
                                            reportData.push(Object.assign({}, detail_header))
                                        }
                                    }
                                    grouper  = reportLine.grouper_id
                                }

                                let description = reportLine.grouper_name
                                let detail = []
                                detail = [
                                        reportLine.site_name,
                                        description,
                                        reportLine.quantity,
                                        this.convertToCurrency(Number(reportLine.amount)),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.cost)), 'Z'),
                                        Math.round(reportLine.margin).toFixed(2) + '%',
                                        this.convertToCurrency(Number(reportLine.margin_value)),
                                ]
                                

                                reportData.push(Object.assign({}, detail))

                                total_qty += Number(reportLine.quantity)
                                total_sales_value += Number(reportLine.amount)
                                total_sales_margin_value += Number(reportLine.margin_value)
                                total_cost_goods_sold += Number(reportLine.cost)

                                grand_qty += Number(reportLine.quantity)
                                grand_sales_value += Number(reportLine.amount)
                                grand_sales_margin_value += Number(reportLine.margin_value)
                                grand_cost_goods_sold += Number(reportLine.cost)

                                if(i == this.salesInvoiceReports.length-1){
                                    if(this.inputGroupBy != ''){
                                    let sub_detail = []
                                    let spacer = grouper_name
                                    
                                    sub_detail = [
                                            {content: spacer, styles: {halign: 'center', fontStyle: 'bold'}},"Total:",
                                            this.convertToCurrency(total_qty),this.convertToCurrency(total_sales_value),
                                            this.addMaskValidation(this.convertToCurrency(total_cost_goods_sold), 'Z'),"",this.convertToCurrency(total_sales_margin_value)
                                    ]
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, sub_detail))
                                    }
                                

                                    reportData.push(Object.assign({}, ["rowLine"]))

                                    reportData.push(Object.assign({}, ['','Grand Total :', this.convertToCurrency(grand_qty),
                                        this.convertToCurrency(grand_sales_value),this.addMaskValidation(this.convertToCurrency(grand_cost_goods_sold), 'Z'),
                                        '',this.convertToCurrency(grand_sales_margin_value)
                                    ]))
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""
                                    
                                    current_grouper = reportLine.grouper_id
                                    next_grouper = this.salesInvoiceReports[i+1].grouper_id  
                                
                                    if(current_grouper != next_grouper){
                                        if(this.inputGroupBy != ''){
                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            let sub_detail = []

                                            let spacer = grouper_name
                                            sub_detail = [
                                                {content: spacer, colSpan:2, styles: {halign: 'center', fontStyle: 'bold'}},"Total:",
                                                this.convertToCurrency(total_qty),this.convertToCurrency(total_sales_value),
                                                this.addMaskValidation(this.convertToCurrency(total_cost_goods_sold), 'Z'),"",this.convertToCurrency(total_sales_margin_value)
                                            ]
                                            reportData.push(Object.assign({}, sub_detail))

                                            total_qty = 0
                                            total_sales_value = 0
                                            total_sales_margin_value = 0
                                            total_cost_goods_sold = 0
                                        }
                                        
                                    }
                                }
                            }
                        }


                        design_x = 280
                        design_y = 200
                        
                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Daily Sales Invoice Report" + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);

                        doc.text(15,30,date_filter);
                        doc.text(15,34,site_filter);
                        doc.text(15,38,division_filter);
                        doc.text(15,42,group_filter);

                        let colStyles = {}

                        colStyles = {
                            0: {cellWidth: 50,halign: 'center'},
                            1: {cellWidth: 40,halign: 'center'},
                            2: {cellWidth: 'auto',halign: 'right'},
                            3: {cellWidth: 40,halign: 'right'},
                            4: {cellWidth: 40,halign: 'right'},
                            5: {cellWidth: 40,halign: 'right'},
                            6: {cellWidth: 40,halign: 'right'}
                        }


                        doc.autoTable({
                            startY: 46,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            margin: { bottom: 30 },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right',
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[0] == 'Grand Total :' || data.row.raw[3] == 'Grand Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });


                    }
                    // end loop

                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }

                    let pageCount = doc.internal.getNumberOfPages();
                    
                    for(let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "Sales Invoice" + group_text, design_x, design_y, i, pageCount)
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                    // doc.save(`Item_Sales_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x,'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning = false;

            },
            async generateExcel(){
                this.spinning = true;
                const workbook = new ExcelJS.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();
                const sheet = workbook.addWorksheet("Sales Invoice Report", {
                    pageSetup:{paperSize: 9}
                });

                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                const data_starts_at_row = 11

                let site_filter,date_filter,division_filter,group_filter

                let groupBy = this.groupOptions.find(x => x.key == this.inputGroupBy).value
                let sortBy = this.sortOptions.find(x => x.key == this.inputSortBy).value
                group_filter = `Group By ${groupBy} Order by ${sortBy} ${this.showSortInfo}`
                date_filter = `For the Period of ${from_date} to ${to_date}`
                
                if(this.inputSite != undefined && this.inputSite.length > 0 && this.inputSite != [] && this.inputSite.length != this.siteOptions.length){
                    let sites = this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name)
                    site_filter = "Sites: " + sites 
                }else{
                    site_filter = "Sites: All Sites"
                }

                if(this.inputDivision != undefined && this.inputDivision.length > 0 && this.inputDivision != []){
                    let division = this.divisionOptions.filter(x => this.inputDivision.includes(x.id)).map(x => x.name)
                    division_filter = "Divisions: " + division
                }else{
                    division_filter = "Divisions: All Divisions"
                }

                let printed_by = secureStorage.getItem("email")
                if(printed_by == null){
                    printed_by = ''
                }
                let dateNow = moment().format('LL');


                sheet.getRow(2).values = ["Sales Invoice Report"]
                sheet.getRow(4).values = [`${date_filter}`]
                sheet.getRow(5).values = [`${site_filter}`]
                sheet.getRow(6).values = [`${division_filter}`]
                sheet.getRow(7).values = [`${group_filter}`]
                sheet.getRow(8).values = [`Printed By ${printed_by}`]
                sheet.getRow(9).values = [`Run Date ${dateNow}`]
                
                //custom header
                let description = "Description"
                if(this.inputGroupBy == "division_id,site"){
                    description = "Division Name"
                }

                sheet.getRow(data_starts_at_row).values = ["Site Name", description, "Qty", "Amount","Cost","Sales Margin","Sales Margin Value"];

                sheet.columns = [
                    { key: "site_name" , width: 15 },
                    { key: "description" , width: 15 },
                    { key: "qty", width: 15 },
                    { key: "amount" , width: 15 },
                    { key: "cost", width: 15 },
                    { key: "margin", width: 15 },
                    { key: "margin_value", width: 15 },
                ];

                var sales_report = this.JsonData
                // var sales_report = get_request[0].sales_report
                // console.log("details", sales_report)

                var rowDatas = []
                var horizontal_range = 0
                for(let i = 0; i < sales_report.length; i++){
                    const report_detail = sales_report[i]
                        if(report_detail){
                            const rowData = {"site_name": report_detail["Site Name"], qty: report_detail["Qty"],description: report_detail[`${description}`],
                            amount: report_detail["Amount"], 
                            cost: report_detail["Cost"] , margin: report_detail["Sales Margin"],
                            margin_value: report_detail["Sales Margin Value"],}
                            rowDatas.push(rowData)
                        }
                    }

                sheet.addRows(rowDatas);

                //styles
                sheet.getRow(2).font = { bold: true, size: 16 };
                sheet.getRow(2).height = 20;
                sheet.getRow(11).font = { bold: true };

                // sheet.getRow(data_starts_at_row).eachCell({ includeEmpty: true }, function(cell) {
                //     sheet.getCell(cell.address).fill = { type: 'pattern', pattern: 'darkVertical', fgColor: { argb: '89CFF0'}}
                // })

                sheet.eachRow(function (Row, rowNum) {
                    if(rowNum >= data_starts_at_row){
                        Row.eachCell(function (Cell, cellNum) {
                            if (rowNum == data_starts_at_row) {
                                Cell.alignment = {
                                    horizontal: 'center'
                                }
                            }
                            else{
                                Cell.alignment = {
                                    vertical: 'middle',
                                    horizontal: 'left'
                                }
                            }
                        })
                    }
                })
                
                workbook.xlsx.writeBuffer().then(function(buffer) {
                    const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                    saveAs(blob, `DailySalesReport.xlsx`);
                });
                this.JsonData = []
                this.spinning =false
            },
            generateFile: async function() {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "group_by": this.inputGroupBy,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "division_id": this.inputDivision.toString()
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'sales_report_with_invoice?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                    return
                }

                console.log(get_request)
                let description = "Description"
                if(this.inputGroupBy == "division_id,site"){
                    description = "Division Name"
                }
                if(get_request.length > 0){
                    let siteSpecific = get_request;
                    let headers = ["Site Name", description, "Qty", "Amount", "Cost", "Sales Margin", "Sales Margin Value"];
                    let site_specific = [];

                    for(let x=0; x < siteSpecific.length; x++){
                        this.salesInvoiceReports = siteSpecific[x].sales_report

                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push(headers)
                        }

                        if(this.salesInvoiceReports.length > 0){
                            let total_qty = 0
                            let total_sales_value = 0
                            let total_sales_margin_value = 0
                            let total_cost_goods_sold = 0

                            let grand_qty = 0
                            let grand_sales_value = 0
                            let grand_sales_margin_value = 0
                            let grand_cost_goods_sold = 0

                            let grouper = 'start'
                            for(let i=0; i < this.salesInvoiceReports.length; i++){
                                let reportLine = this.salesInvoiceReports[i]
                                let grouper_name = reportLine.grouper_name
                                let grouper_id = reportLine.grouper_id

                                if(grouper == 'start'){
                                    let detail_header = [grouper_name];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != grouper_id){
                                        let detail_header = [grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id
                                let description = reportLine.grouper_name

                                let detail = []
                                detail = [
                                    reportLine.site_name,
                                    description,
                                    reportLine.quantity,
                                    this.convertToCurrency(Number(reportLine.amount)),
                                    this.convertToCurrency(Number(reportLine.cost)),
                                    Math.round(reportLine.margin).toFixed(2) + '%',
                                    this.convertToCurrency(Number(reportLine.margin_value)),
                                ]

                                total_qty += Number(reportLine.quantity)
                                total_sales_value += Number(reportLine.amount)
                                total_cost_goods_sold += Number(reportLine.cost)
                                total_sales_margin_value += Number(reportLine.margin_value)

                                grand_qty += Number(reportLine.quantity)
                                grand_sales_value += Number(reportLine.amount)
                                grand_cost_goods_sold += Number(reportLine.cost)
                                grand_sales_margin_value += Number(reportLine.margin_value)

                                reportData.push(Object.assign({}, detail))

                                let sub_detail = []
                                if(i == this.salesInvoiceReports.length-1){
                                    //Subtotal
                                    sub_detail = ['','Sub Total :',
                                            this.convertToCurrency(total_qty),
                                            this.convertToCurrency(total_sales_value),
                                            this.addMaskValidation(this.convertToCurrency(total_cost_goods_sold), 'Z'),
                                            '',
                                            this.convertToCurrency(total_sales_margin_value)
                                        ]
                                    reportData.push(Object.assign({}, sub_detail))

                                    //Grand Total
                                    let grand_detail = ['','Grand Total :',
                                        this.convertToCurrency(grand_qty),
                                        this.convertToCurrency(grand_sales_value),
                                        this.addMaskValidation(this.convertToCurrency(grand_cost_goods_sold), 'Z'),
                                        '',
                                        this.convertToCurrency(grand_sales_margin_value)
                                    ]
                                    reportData.push(Object.assign({}, grand_detail));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.document_date
                                    next_grouper = this.salesInvoiceReports[i+1].document_date

                                    if(current_grouper != next_grouper){
                                        //Subtotal
                                        sub_detail = ['','Sub Total :',
                                            this.convertToCurrency(total_qty),
                                            this.convertToCurrency(total_sales_value),
                                            this.addMaskValidation(this.convertToCurrency(total_cost_goods_sold), 'Z'),
                                            '',
                                            this.convertToCurrency(total_sales_margin_value)
                                        ]

                                        reportData.push(Object.assign({}, sub_detail))

                                        total_qty = 0
                                        total_sales_value = 0
                                        total_cost_goods_sold = 0
                                        total_sales_margin_value = 0
                                    }
                                }
                            }

                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.sortOptions[0].value
                        }


                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        // reportData.push(["Sales Invoice Report" + group_text, "Generated By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                        // reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                            var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                [val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'No Data.');
                }
                this.spinning = false;
            },
            clearJsonData(){
              this.JsonData = [];
            },
            async getDivisionOptions() {
                var divisions = await HTTPRequest.getRequest(
                    this.endPoint + "/categories/get_valid_categories?level=1",
                    null,
                    null
                );
                // brands.unshift({code: null, id: null, name: '' })
                this.divisionOptions = divisions;  
            },
        }
    };
</script>

<style></style>
